import { QueryKey, useQuery } from "@tanstack/react-query";
import { projectApi } from "../api/project";
import { queryClient } from "../../../shared/providers/QueryProvider";

export const useStages = ({ searchKey, portfolioId, isPinned, quickFilters, page, limit }: { searchKey: string, portfolioId: string | undefined, isPinned: boolean, quickFilters: { region: string[] | null, programme: string[] | null, site: string[] | null }, page: number, limit: number }) => {

    const { data, isLoading, isError, refetch } = useQuery({
        queryKey: ["project-listing-stages", searchKey, portfolioId, isPinned, quickFilters['region'], quickFilters['programme'], quickFilters['site'], page, limit] as QueryKey,
        queryFn: () => projectApi.fetchProjectStages({ search_term: searchKey, portfolio_id: portfolioId, is_pinned: isPinned, region_id: quickFilters["region"], programme_id: quickFilters["programme"], site_id: quickFilters["site"] }),
    });

    return {
        stagesData: data?.data || [],
        isLoading,
        isError,
        refetch,
        removeCachePinned: () => { queryClient.removeQueries({ queryKey: ["project-listing-stages", searchKey, portfolioId, true, quickFilters['region'], quickFilters['programme'], quickFilters['site']] }); },
        removeCacheUnpinned: () => { queryClient.removeQueries({ queryKey: ["project-listing-stages", searchKey, portfolioId, false, quickFilters['region'], quickFilters['programme'], quickFilters['site']] }); }
    };

}